import React, { Component } from 'react';
import Spinner from '../commonFiles/Spinner';
import UserInfo from './UserInfo';
class UserApp extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){

}


  render() {
    return (
        <div className="container-xxl bg-white p-0">
          <div className="container-fluid">
          <div className="row">
          <UserInfo/>
          </div>
          </div>
          <Spinner/>
        </div>
    );
  }
}

export default UserApp;
